import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { number } from '~/helpers';
import { UnidataTable } from '~/components';
import {
  deleteProduto,
  findProduto,
  recordFiltering,
} from '~/store/modules/produto/actions';

import MyForm from './form';

export default function Produto() {
  const data = useSelector((state) => state.produto);

  const optionSN = useMemo(
    () => [
      { value: 'Sim', label: 'Sim' },
      { value: 'Não', label: 'Não' },
    ],
    []
  );

  const optionType = useMemo(
    () => [
      { value: 'Lubrificante', label: 'Lubrificante' },
      { value: 'Combustível', label: 'Combustível' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'prod_codigo',
        label: 'Código',
        align: 'center',
        filter: {
          type: 'number',
        },
      },
      {
        id: 'prod_descricao',
        label: 'Descrição',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_display',
        label: 'Display',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_codigo_aux',
        label: 'Cód. Aux',
        align: 'center',
        filter: {
          type: 'number',
        },
      },
      {
        id: 'prod_percentual_perdasobra',
        label: '% Perdas/Sobras',
        align: 'right',
        formatted: (value) => number(value, 2),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_dens_max_20',
        label: 'Desn. Max. 20°',
        align: 'right',
        formatted: (value) => number(value, 4),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_dens_min_20',
        label: 'Desn. Min. 20°',
        align: 'right',
        formatted: (value) => number(value, 4),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_var_max_dens_20',
        label: 'Var. Max. Dens',
        align: 'right',
        formatted: (value) => number(value, 4),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'prod_tipo_string',
        label: 'Tipo',
        formatted: (value) =>
          optionType.find((option) => option.label === value).value,
        filter: {
          type: 'select',
          options: optionType,
        },
      },
      {
        id: 'prod_trata_agua_string',
        label: 'Trata Água',
        formatted: (value) =>
          optionSN.find((option) => option.label === value).value,
        align: 'center',
        filter: {
          type: 'select',
          options: optionSN,
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="poco_desc_abrev ASC"
      read={recordFiltering}
      remove={deleteProduto}
      redux={data}
      header={header}
      form={MyForm}
      find={findProduto}
      detach="prod_descricao"
      keys="prod_codigo"
      view="VW_PRODUTO"
      reportTitle="Cadastro de Produto"
    />
  );
}
